import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";

export const areCustomerDetailsFilled = (customerDetails: ICustomerDetails | undefined): boolean => {
    if (!customerDetails) {
        return false;
    }

    const customerDetailsFilled =
        Boolean(customerDetails.email) &&
        Boolean(customerDetails.firstName) &&
        Boolean(customerDetails.lastName) &&
        Boolean(customerDetails.birthDate) &&
        Boolean(customerDetails.contactPermission) &&
        Boolean(customerDetails.billingAddress) &&
        Boolean(customerDetails.deliveryAddress);

    return customerDetailsFilled;
};
